<!--
 - Order List Header Component HTML (header.component.html).
 -
 - @version
 - 4.74.0 OAUI-713 Unable to update order status for multiple orders
 - 4.73.0 OAUI-711 Rename Lookahead Orders as Spooling Orders
 - 4.71.0 OAUI-693 Tidy and remove duplicated code
 - 4.71.0 OAUI-684 Improve shared code and add interfaces
 - 4.71.0 OAUI-682 Rebuild list work/lookahead orders page and improve usability
 - 4.70.0 OAUI-678 Build "Driver Assignment" UI
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.48.0 OAUI-582 Add Date Range Filter for Orders
 - 4.46.0 OAUI-572 Remove references to order-admin-api
 - 4.44.0 OAUI-564 Add button on Work Orders for CSV export
 - 4.38.0 OAUI-538 Local storage is not working as expected
 - 4.38.0 OAUI-537 Toggle table columns on order list table
 - 4.37.0 OAUI-527 Slowdowns in order modals
 - 4.37.0 OAUI-532 Add missing filters for v2 orders list
 - 4.36.0 OAUI-517 Work Orders V2: add UI for adding a lookahead order
 - 4.36.0 OAUI-505 Page number on top vs bottom navigation differs
 - 4.35.0 OAUI-496 Add header and missing fields
 - 4.34.0 OAUI-492 Fulfillment groups display is stacking
 - 4.34.0 OAUI-489 Update multiple order statuses based on selection
 - 4.34.0 OAUI-479 Optimize the list orders page to avoid overloaded SCSS files
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2022-2024 Build Centrix
 -->
<div class="bcx-page-header-container orders-header">
  <div class="col-sm-12" *ngIf="showHeader">
    <app-bcx-page-header [pageTitle]="pageTitle" [pageSubtitle]="pageSubtitle">
      <div filters-button>
        <bc-atoms-button
          id="btnFilters"
          icon="filter"
          display="block"
          label="{{'order.filters.title.plural'|translate }}"
          title="{{'order.filters.description'|translate }}"
          size="small"
          type="default"
          [iconOnly]="true"
          (onButtonClicked)="handleFiltersClick()"
        >
        </bc-atoms-button>
      </div>
      <div exports-button>
        <!--Exports: dropdown -->
        <bc-atoms-button
          label="{{'exports.title'|translate }}"
          title="{{'exports.description'|translate }}"
          icon="export"
          display="block"
          size="small"
          [disabled]="false"
          [iconOnly]="true"
        >
          <div dropdown-content>
            <form class="m-2">
              <!--Exports-->
              <bc-atoms-input-group
                labelIcon="all"
                labelTitle="{{'exports.title'|translate}}"
                labelDescription="{{'exports.description'|translate}}"
              >
                <a
                  class="dropdown-item"
                  href="{{this.wdOrdersV2Service.getWorkOrdersCsvUrl()}}"
                  target="target"
                >
                  <bc-atoms-icon type="csv"></bc-atoms-icon>
                  <label
                    >{{'exports.workOrders.workOrders_csv'|translate}}</label
                  >
                </a>
              </bc-atoms-input-group>
            </form>
          </div>
        </bc-atoms-button>
      </div>
      <div
        add-button
        [hidden]="orderType !== wdLocalSharedFunctions.orderTypeKey.LOOKAHEAD"
      >
        <!--Add Spooling Order-->
        <bc-atoms-button
          id="btnAddLookahead"
          icon="add"
          display="block"
          label="{{'order.types.lookahead.title'|translate }}"
          title="{{'order.types.lookahead.description'|translate }}"
          size="small"
          type="primary"
          (onButtonClicked)="addLookahead()"
        >
        </bc-atoms-button>
      </div>
    </app-bcx-page-header>
  </div>
  <div class="col-sm-12" *ngIf="showFilters">
    <app-bcx-page-filters>
      <div navigation>
        <!--First Page-->
        <bc-atoms-button
          id="first"
          icon="first"
          display="block"
          size="small"
          title="{{'actions.navigation.first.description'|translate }}"
          type="default"
          [disabled]="wdOrdersV2Service.orderViewSettings.page === 1"
          (onButtonClicked)="goFirstPage()"
        >
        </bc-atoms-button>

        <!--Current Page-->
        <bc-atoms-button
          id="currentPage"
          display="block"
          size="small"
          type="default"
          disabled="true"
          [label]="'actions.page'|translate: { page:wdOrdersV2Service.orderViewSettings.page }"
          [title]="'actions.page'|translate: { page:wdOrdersV2Service.orderViewSettings.page }"
        >
        </bc-atoms-button>

        <!--Next Page-->
        <bc-atoms-button
          id="next"
          icon="forward"
          display="block"
          size="small"
          title="{{'actions.navigation.next.description'|translate }}"
          type="default"
          [disabled]="this.wdOrdersV2Service.allOrders.value.length < wdOrdersV2Service.orderViewSettings.pageSize"
          (onButtonClicked)="goNextPage()"
        >
        </bc-atoms-button>
      </div>
      <div settings>
        <bc-atoms-button
          id="settings"
          icon="webduct"
          display="block"
          size="small"
          [disabled]="wdOrdersV2Service.isReloadingOrders.value===true"
          title="{{'order.settings.description'|translate }}"
          type="default"
        >
          <div dropdown-content>
            <form class="m-2">
              <!--Page Size-->
              <bc-atoms-input-group
                labelIcon="workOrders"
                labelTitle="{{'labels.pageSize'|translate}}"
                labelDescription="{{'labels.pageSize'|translate}}"
              >
                <div class="sub-item">
                  <bc-atoms-button-group
                    direction="horizontal"
                    size="small"
                    selectedType="primary"
                    [options]="pageSizeOptions"
                    [(model)]="wdOrdersV2Service.orderViewSettings.pageSize"
                    (onSelectionChanged)="setPageSize(wdOrdersV2Service.orderViewSettings.pageSize, true)"
                  ></bc-atoms-button-group>
                </div>
              </bc-atoms-input-group>
              <!--Fulfillment Groups-->
              <bc-atoms-input-group
                labelIcon="all"
                labelTitle="{{'order.fulfillment.title'|translate}}"
                labelDescription="{{'order.fulfillment.title'|translate}}"
              >
                <!--Toggle Empty Fulfillment Groups-->
                <div class="item">
                  <bc-atoms-checkbox
                    [label]="'actions.showType'|translate: {type:('order.fulfillment.groups.empty'|translate)}"
                    [title]="'actions.showType'|translate: {type:('order.fulfillment.groups.empty'|translate)}"
                    [(model)]="wdOrdersV2Service.orderViewSettings.groups.fulfillment.showEmpty"
                    (onCheckboxClicked)="setToggleEmptyFulfillmentGroupsOption(wdOrdersV2Service.orderViewSettings.groups.fulfillment.showEmpty)"
                  ></bc-atoms-checkbox>
                </div>
              </bc-atoms-input-group>
              <!--Toggle Columns-->
              <bc-atoms-input-group
                labelIcon="all"
                labelTitle="{{'order.columns.toggle.title'|translate}}"
                labelDescription="{{'order.columns.toggle.description'|translate}}"
              >
                <!--Toggle Order Columns-->
                <div
                  class="item"
                  *ngFor="let column of wdOrdersService.orderListColumnsOptions"
                >
                  <bc-atoms-checkbox
                    *ngIf="column.canToggle"
                    [label]="column.label"
                    [title]="column.description"
                    [(model)]="column.selected"
                    (onCheckboxClicked)="setToggledColumns()"
                  >
                  </bc-atoms-checkbox>
                </div>
              </bc-atoms-input-group>
            </form>
          </div>
        </bc-atoms-button>
      </div>
      <div
        date-type
        [hidden]="wdOrdersV2Service.isLoadingOrders.value === true"
      >
        <!--Date Type-->
        <bc-atoms-dropdown
          id="dateType"
          name="dateType"
          title="{{'order.filters.type.description'|translate}}"
          placeholder="{{'order.filters.type.title'|translate}}"
          iconKey="type"
          labelKey="label"
          label="{{'order.filters.type.empty'|translate}}"
          size="small"
          display="block"
          [requireSelection]="false"
          [loading]="wdOrdersV2Service.isReloadingOrders.value===true"
          [disabled]="wdOrdersV2Service.isReloadingOrders.value===true"
          [options]="wdOrdersV2Service?.dateTypeFilterOptions"
          [(model)]="wdOrdersV2Service.orderFilters.value.dateType"
          (modelChange)="wdOrdersV2Service.liveFilterChanged('dateType', $event)"
        >
        </bc-atoms-dropdown>
      </div>
      <div date-start *ngIf="wdOrdersV2Service.orderFilters.value.dateType">
        <!--Filter Start-->
        <bc-atoms-date-picker
          id="dateStart"
          name="dateStart"
          placeholder="{{'order.filters.start.title'|translate}}"
          title="{{'order.filters.start.description'|translate}}"
          size="small"
          [disabled]="!wdOrdersV2Service.orderFilters.value.dateType || wdOrdersV2Service.isReloadingOrders.value===true"
          [dateFormat]="wdEnvironmentService.dateFormat"
          [(model)]="wdOrdersV2Service.orderFilters.value.dateStart"
          (modelChange)="wdOrdersV2Service.liveFilterChanged('dateStart', $event)"
        >
        </bc-atoms-date-picker>
      </div>
      <div date-end *ngIf="wdOrdersV2Service.orderFilters.value.dateType">
        <!--Filter End-->
        <bc-atoms-date-picker
          id="dateEnd"
          name="dateEnd"
          placeholder="{{'order.filters.end.title'|translate}}"
          title="{{'order.filters.end.description'|translate}}"
          size="small"
          [disabled]="!wdOrdersV2Service.orderFilters.value.dateType || wdOrdersV2Service.isReloadingOrders.value===true"
          [dateFormat]="wdEnvironmentService.dateFormat"
          [(model)]="wdOrdersV2Service.orderFilters.value.dateEnd"
          (modelChange)="wdOrdersV2Service.liveFilterChanged('dateEnd', $event)"
        >
        </bc-atoms-date-picker>
      </div>
      <div
        select-action
        *ngIf="wdOrdersService.orderListSelections.selected?.length > 0 && wdEnvironmentService.values.permissions.canChangeOrderStatus"
      >
        <!--Update Order Statuses-->
        <bc-atoms-dropdown
          id="btnUpdateStatuses"
          display="block"
          idKey="id"
          iconKey="type"
          labelKey="label"
          type="default"
          size="small"
          [label]="('order.statuses.overall.update.title'|translate)"
          [title]="('order.statuses.overall.update.description'|translate)"
          [badge]="wdOrdersService.orderListSelections.selected?.length"
          [model]="updateStatusesValue"
          [options]="wdOrdersV2Service.orderFilters.value.orderStatuses"
          [requireSelection]="true"
          [disabled]="false"
          [loading]="updatingStatuses"
          (modelChange)="updateOrderStatuses($event).then(); updateStatusesValue = $event"
        ></bc-atoms-dropdown>
      </div>
      <!--Job Name/Number-->
      <div filter-1 [hidden]="wdOrdersV2Service.isLoadingOrders.value === true">
        <input
          id="jobFilter"
          name="jobFilter"
          type="text"
          class="form-control form-control-sm"
          title="{{'order.filters.job.description'|translate}}"
          placeholder="{{'order.filters.job.title'|translate}}"
          [class.is-invalid]="wdJobService.searchingJobsFailed"
          [editable]="false"
          [resultTemplate]="rt"
          [inputFormatter]="wdJobService.typeaheadSearchJobsFormatter"
          [disabled]="wdOrdersV2Service.isReloadingOrders.value===true"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="wdOrdersV2Service.orderFilters.value.jobFilter"
          (ngModelChange)="wdOrdersV2Service.liveFilterChanged('jobFilter', $event)"
          [ngbTypeahead]="wdJobService.typeaheadSearchJobs"
          (blur)="typeaheadJobBlur(wdOrdersV2Service.orderFilters.value.jobFilter)"
        />
        <ng-template #rt let-r="result" let-t="term">
          <ngb-highlight
            [result]="r.number + ' ' + r.name"
            [term]="t"
          ></ngb-highlight>
        </ng-template>
      </div>
      <!--Ordered For-->
      <div filter-2 [hidden]="wdOrdersV2Service.isLoadingOrders.value === true">
        <bc-atoms-typeahead
          id="orderedForFilter"
          name="orderedForFilter"
          title="{{'order.filters.orderedFor.description'|translate}}"
          placeholder="{{'order.filters.orderedFor.title'|translate}}"
          labelKey="fullName"
          size="small"
          [canClear]="true"
          [disabled]="wdOrdersV2Service.isReloadingOrders.value===true"
          [options]="(wdOrdersV2Service.orderFilters | async)?.users"
          [(model)]="wdOrdersV2Service.orderFilters.value.orderedForFilter"
          (modelChange)="wdOrdersV2Service.liveFilterChanged('orderedForFilter', $event)"
        >
        </bc-atoms-typeahead>
      </div>
      <!--Organization-->
      <div filter-3 [hidden]="wdOrdersV2Service.isLoadingOrders.value === true">
        <bc-atoms-typeahead
          id="organizationFilter"
          name="organizationFilter"
          title="{{'order.filters.organization.description'|translate}}"
          placeholder="{{'order.filters.organization.title'|translate}}"
          labelKey="name"
          size="small"
          [canClear]="true"
          [disabled]="wdOrdersV2Service.isReloadingOrders.value===true"
          [options]="(wdOrdersV2Service.orderFilters | async)?.organizations"
          [(model)]="wdOrdersV2Service.orderFilters.value.organizationFilter"
          (modelChange)="wdOrdersV2Service.liveFilterChanged('organizationFilter', $event)"
        >
        </bc-atoms-typeahead>
      </div>
      <!--Order Number-->
      <div filter-4 [hidden]="wdOrdersV2Service.isLoadingOrders.value === true">
        <bc-atoms-input
          id="orderNumberFilter"
          name="orderNumberFilter"
          title="{{'order.filters.orderNumber.description'|translate}}"
          placeholder="{{'order.filters.orderNumber.title'|translate}}"
          size="small"
          [disabled]="wdOrdersV2Service.isReloadingOrders.value===true"
          [(model)]="wdOrdersV2Service.orderFilters.value.orderNumberFilter"
          (modelChange)="wdOrdersV2Service.liveFilterChanged('orderNumberFilter', $event)"
        ></bc-atoms-input>
      </div>
    </app-bcx-page-filters>
  </div>
</div>
